import React, { useEffect, useRef, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { ThCell } from '../../../../common/table/ThCell'

export const HeaderTable = ({
  headerTable,
  sort,
  changeSort,
  isDynamicReport,
}) => {
  const ref = useRef()
  const [oneRowHeight, setOneRowHeight] = useState(0)

  useEffect(() => {
    setOneRowHeight(ref.current?.getBoundingClientRect().height)
  }, [headerTable])

  return (
    <>
      <tr ref={ref}>
        {headerTable.map((col, colIndex) => {
          return (
            <React.Fragment key={colIndex}>
              {!col.childCol ? (
                <ThCell
                  col={{
                    ...col,
                    sortable: !isDynamicReport,
                    thStyle: {
                      whiteSpace: 'nowrap',
                    },
                    renderTh: () => <Translate value={col.title} />,
                  }}
                  sticky
                  isNoStickyHead={isDynamicReport}
                  style={col.style}
                  rowSpan={2}
                  sort={sort}
                  changeSort={changeSort}
                />
              ) : (
                <ThCell
                  style={{ padding: '1px 2px', border: 'none' }}
                  isNoStickyHead={isDynamicReport}
                  colSpan={col.childCol.length}
                  col={{
                    ...col,
                    thStyle: {
                      whiteSpace: 'nowrap',
                      justifyContent: isDynamicReport ? 'flex-end' : 'center',
                      backgroundColor: '#F3F3F3',
                      padding: isDynamicReport ? '4px 10px' : 4,
                    },
                  }}
                />
              )}
            </React.Fragment>
          )
        })}
      </tr>
      <tr>
        {headerTable
          .filter((item) => item.childCol)
          .map((parentCol, parentColIndex) => {
            return (
              <React.Fragment key={parentColIndex}>
                {parentCol.childCol.map((childCol, childColIndex) => {
                  return (
                    <ThCell
                      key={childColIndex}
                      style={{
                        padding: '0 2px',
                        top: oneRowHeight,
                      }}
                      col={{
                        ...childCol,
                        sortable: !isDynamicReport,
                        thStyle: {
                          whiteSpace: 'nowrap',
                          justifyContent: 'flex-end',
                          backgroundColor: '#F3F3F3',
                          padding: isDynamicReport ? '4px 10px' : 4,
                        },
                        renderTh: () => <Translate value={childCol.title} />,
                      }}
                      isNoStickyHead={isDynamicReport}
                      sort={sort}
                      changeSort={changeSort}
                    />
                  )
                })}
              </React.Fragment>
            )
          })}
      </tr>
    </>
  )
}
